import { createContext, use } from "react";

import type { useEposDisplay } from "./use-epos-display";

export type EposContext = ReturnType<typeof useEposDisplay>;

export const EposContext = createContext<EposContext | undefined>(undefined);

export const useEposContext = () => {
	const context = use(EposContext);
	if (!context) {
		throw new Error("useEposContext must be used within a EposContextProvider");
	}

	return context;
};
